import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getUsuarioLogado } from '../services/LoginService';
import { PageLoader } from './ui';

function PrivateRoute({ children, somenteAdmin = false }) {
  const [loading, setLoading] = useState(true);
  const [autenticado, setAutenticado] = useState(false);
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    async function verificarLogin() {
      try {
        const user = await getUsuarioLogado();
        setUsuario(user);
        setAutenticado(true);
      } catch (error) {
        setAutenticado(false);
      } finally {
        setLoading(false);
      }
    }

    verificarLogin();
  }, []);

  if (loading) {
    return <PageLoader label="Carregando..." />;
  }

  if (!autenticado) return <Navigate to="/" replace />;

  if (somenteAdmin) {
    const cargo = String(usuario?.cargo || '').trim().toLowerCase();
    if (cargo !== 'admin') {
      return <Navigate to="/parceiros" replace />;
    }
  }

  return children;
}

export default PrivateRoute;
